module.exports = __webpack_public_path__ + "img/success.348e5bc3.png";